import { render, staticRenderFns } from "./hpBox.vue?vue&type=template&id=5b98f651&"
import script from "./hpBox.vue?vue&type=script&lang=js&"
export * from "./hpBox.vue?vue&type=script&lang=js&"
import style0 from "./hpBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports